import { makeObservable, observable } from 'mobx'

import BarState from '~/client/src/desktop/enums/SideBarState'
import BaseNotification from '~/client/src/shared/models/Notification'
import { isDeliveryType } from '~/client/src/shared/types/NotificationTypes'

export default class NotificationDetailsViewStore {
  @observable private displayedDetailsType: BarState = BarState.Default
  private displayedContentObjectId: string

  public constructor() {
    makeObservable(this)
  }

  public get deliveryId() {
    return this.displayedDetailsType === BarState.DeliveryDetails
      ? this.displayedContentObjectId
      : null
  }

  public setNotification = (notification: BaseNotification) => {
    if (!notification) {
      return
    }

    const { entityId, type } = notification

    this.displayedContentObjectId = entityId
    switch (true) {
      case isDeliveryType(type):
        this.displayedDetailsType = BarState.DeliveryDetails
        break
      default:
        this.displayedDetailsType = BarState.Default
    }
  }
}
